import {canManageGlacierArchive} from '@netx/core-cart-next/enablers';
import {type ISavedCart} from '../schema';
import {savedCartIsEmpty} from './savedCartIsEmpty';

export const canManageSavedCartArchive = (savedCart?: ISavedCart) => {
	if (savedCartIsEmpty(savedCart)) return false;
	return canManageGlacierArchive();
};

export default canManageSavedCartArchive;
